<template>
  <v-dialog v-model="dialog" persistent max-width="680" :fullscreen="paraMesero && $store.getters.mobile">
    <ValidationObserver v-slot="{ invalid }" ref="form" :tag="paraMesero ? 'div' : 'span'" :class="{ 'observer-mesero': paraMesero }">
      <v-card v-if="product" :class="{ 'modal-mesero': true, 'modal-caja': !paraMesero, 'modal-mesero--full': paraMesero && $store.getters.mobile }">
        <v-app-bar flat color="primary" :height="paraMesero ? 64 : 56">
          <v-avatar v-if="product.image && !paraMesero" tile size="40" class="mr-3 rounded" color="white">
            <v-img :src="getPathProduct(product)"></v-img>
          </v-avatar>
          <v-toolbar-title class="text-h6 white--text pl-0" :class="{ 'titulo-mesero': true }">
            {{ product.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text font-weight-regular pl-0">
            <template v-if="!enablePriceChange && !paraMesero">
              {{ $filters.currency(getProductPrice() * quantity) }}
            </template>
          </v-toolbar-title>
          <v-btn
            color="white"
            icon
            @click="$emit('cancel')"
            :title="$t('Cancel')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-text :style="paraMesero ? '' : 'max-height: 60vh; overflow-y: auto'" :class="{ 'cuerpo-mesero': true }">
          <v-row class="pa-2 fill-height">
            <v-col cols="12" class="pt-2 pb-0 fila-cantidad">
              <div class="fila-precio" v-if="!paraMesero">
              <ng-select-options
                v-if="$pos && $pos.priceLists"
                v-model="currentPriceList"
                :items="$pos.priceLists"
                @change="changePriceList"
                :clearable="false"
                :flat="false"
                :filled="false"
                dense
                :outlined="true"
                :full-width="true"
              ></ng-select-options>

              <v-select
                v-model="discount"
                :items="discountRates"
                :label="$t('discounts')"
                @change="changePriceList"
                dense
                outlined
              >
              </v-select>
              </div>

              <div class="cantidad-mesero" v-if="paraMesero">
                <span class="cantidad-mesero__etiqueta">{{ $t("quantity") }}</span>
                <v-btn icon outlined :disabled="quantity <= 1" @click="minus" aria-label="Quitar uno"><v-icon>mdi-minus</v-icon></v-btn>
                <span class="cantidad-mesero__valor">{{ quantity }}</span>
                <v-btn icon outlined color="primary" @click="quantity++" aria-label="Agregar uno"><v-icon>mdi-plus</v-icon></v-btn>
              </div>

              <div class="cantidad-caja" v-else>
                <ng-number-keyboard
                  v-model="quantity"
                  :label="$t('quantity')"
                  rules="required"
                  :filled="false"
                  dense
                  show-required="true"
                  id="quantity-field"
                  :suffix="esPesado ? unidadDePeso : undefined"
                  @keydown="comaPorPunto"
                ></ng-number-keyboard>
                <v-btn
                  icon
                  outlined
                  class="mx-2"
                  @click="minus"
                  :title="$t('decrease')"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn
                  icon
                  outlined
                  color="primary"
                  @click="mas"
                  :title="$t('increase')"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
              <div v-if="esPesado && !enEscritorio" id="aviso-pesado" class="aviso-pesado caption">
                <v-icon x-small color="primary" class="mr-1">mdi-scale</v-icon>
                Producto por peso: escribe la cantidad en {{ unidadDePeso }} (por ejemplo 0.5 = medio kilo).
                ¿Quieres que la balanza se lea sola? Conecta una balanza y usa el POS de escritorio.
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="mt-0 pt-0 pb-0 fila-cantidad"
              v-if="enablePriceChange"
            >
              <ng-number-keyboard
                v-model="price"
                :label="$t('price')"
                :filled="false"
                dense
                show-required="true"
                rules="required"
                rows="3"
                @change="changePrice"
              ></ng-number-keyboard>
            </v-col>

            <v-col cols="12" class="py-0 fila-nota">
              <v-btn text small color="primary" v-if="!verNota && !note" @click="verNota = true">
                <v-icon left small>mdi-note-plus-outline</v-icon>Agregar nota
              </v-btn>
              <ng-textarea-keyboard
                v-else
                v-model="note"
                :label="$t('note')"
                :filled="false"
                dense
                show-required="true"
                :rows="2"
              ></ng-textarea-keyboard>
            </v-col>

            <v-col
              cols="12"
              v-for="(vr, index) in variants"
              :key="vr.id"
              class="pt-0 fila-variantes"
              :id="'grupo-v' + vr.id"
            >
              <h4 class="mb-1">{{ vr.name }}<span class="caption ml-2 font-weight-bold" :class="variantsItem[vr.id] ? 'grey--text' : 'red--text text--darken-1'">Obligatorio · elige 1</span></h4>
              <v-list-item-group
                v-model="variantsItem[vr.id]"
                class="d-flex flex-row flex-wrap"
              >
                <template v-for="(opt, i) in vr.options">
                  <div
                    class="set-variant rounded pa-0 d-flex"
                    :key="i"
                                      >
                    <v-list-item
                      :value="opt.id"
                      :disabled="isOptionDisabled(opt, vr, index)"
                      @click="selectVariant(opt, vr)"
                      style="border: 1px solid #ccc"
                    >
                      <template v-slot:default="{ active }">
                        <span v-if="!active" class="text-left grey--text">{{
                          opt.name
                        }}</span>
                        <span v-else class="green--text">{{ opt.name }}</span>
                        <v-list-item-action>
                          <v-icon right v-if="!active" color="grey lighten-2"
                            >mdi-check-circle-outline
                          </v-icon>
                          <v-icon right v-else color="green darken-3">
                            mdi-check-circle
                          </v-icon>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </div>
                </template>
              </v-list-item-group>

              <!-- <v-list-item-group v-model="variantsItem[vr.id]" color="primary" class="d-flex flex-row flex-wrap">
                <div v-for="(opt, i) in vr.options" :key="i" class="set-variant">
                  <v-list-item :value="opt.id" :key="i" @click="selectVariant(opt, vr)" style="border: 1px solid #ccc"
                    class="cart-selection-variant-option">
                    <template v-slot:default="{ active }">
                      <span class="text-left">{{ opt.name }}</span>
                      <v-list-item-action>
                        <v-icon v-if="!active" color="grey lighten-3">mdi-check-circle-outline
                        </v-icon>
                        <v-icon v-else color="green darken-3">
                          mdi-check-circle
                        </v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </div>
              </v-list-item-group> -->
              <div v-if="intentado && !variantsItem[vr.id]" class="red--text text--darken-1 font-weight-bold caption mt-1">
                <v-icon x-small color="red darken-1">mdi-alert-circle</v-icon> Elige {{ vr.name }}
              </div>
            </v-col>

            <v-col cols="12" class="pt-0 fila-variantes" v-for="opt in options" :key="opt.id" :id="'grupo-' + opt.id">
              <CartSectionProductSaleOptions
                :option="opt"
                @selectedOption="selectedOption"
                :itemLine="itemLine"
                :currentList="getPriceListId()"
              ></CartSectionProductSaleOptions>
              <div v-if="opcionesFaltantes[opt.id]" class="red--text text--darken-1 font-weight-bold caption mt-1">
                <v-icon x-small color="red darken-1">mdi-alert-circle</v-icon> {{ opcionesFaltantes[opt.id] }}
              </div>
            </v-col>
            <!--v-col cols="12" style="color: red">
                    <div v-for="(msg, index) in messages" :key="index">
                  <span>{{msg.message}}</span>
                </div>
                </v-col-->
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pie-mesero">
          <v-btn text large @click="$emit('cancel')">{{ $t("Cancel") }}</v-btn>
          <v-btn large depressed :color="pendiente() ? 'orange darken-2' : 'primary'" class="pie-mesero__agregar"
            :disabled="invalid || !cantidadValida" @click="update">
            {{ textoBoton() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<style>
/* En la caja, más ancho: tres por fila. */
.modal-mesero.modal-caja .set-variant {
  flex: 1 1 30%;
  max-width: 33.33%;
}

.modal-mesero.modal-caja .opcion-venta {
  flex: 1 1 30%;
  max-width: 33.33% !important;
  min-height: 52px;
}

/* Variantes y opciones de venta de meseros: la misma cuadrícula y el mismo «elegido» en violeta. */
.modal-mesero .set-variant {
  flex: 1 1 45%;
  max-width: 50%;
}

.modal-mesero .set-variant .v-list-item {
  flex: 1 1 auto;
  min-height: 52px;
  padding: 0 10px;
}

.modal-mesero .set-variant span.grey--text,
.modal-mesero .set-variant span.green--text,
.modal-mesero .opcion-venta .text-left {
  color: rgba(0, 0, 0, 0.87) !important;
}

.modal-mesero .set-variant .v-list-item--disabled {
  opacity: 0.5;
  text-decoration: line-through;
}

.modal-mesero .v-list-item.v-item--active {
  border: 2px solid var(--v-primary-base) !important;
  background: rgba(94, 53, 177, 0.1) !important;
  font-size: 0.875rem !important;
  font-weight: 700;
}

.modal-mesero .v-item--active .v-icon {
  color: var(--v-primary-base) !important;
}

.pie-mesero .pie-mesero__agregar {
  flex: 1 1 0;
  min-width: 0 !important;
  max-width: 100%;
  overflow: hidden;
}

.pie-mesero .pie-mesero__agregar .v-btn__content {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  line-height: 1.15;
  text-align: center;
}
</style>
<style scoped>
.fila-precio {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cantidad-caja {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.cantidad-caja > .v-btn {
  margin-top: 4px;
}

.modal-mesero--full {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
}

.modal-mesero .titulo-mesero {
  white-space: normal;
  font-size: 1.05rem !important;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.modal-mesero--full .cuerpo-mesero {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.modal-mesero--full > .v-toolbar,
.modal-mesero--full > .pie-mesero {
  flex: 0 0 auto;
}

.modal-mesero .cuerpo-mesero .row {
  display: flex;
  height: auto !important;
  align-content: flex-start;
}

.modal-mesero .fila-variantes {
  order: 1;
}

.modal-mesero .fila-cantidad {
  order: 2;
}

.modal-mesero .fila-nota {
  order: 3;
  margin-top: 16px;
}

.cantidad-mesero {
  display: flex;
  align-items: center;
  gap: 14px;
}

.cantidad-mesero__etiqueta {
  flex: 1;
  font-weight: 700;
}

.cantidad-mesero__valor {
  min-width: 32px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 800;
}

.pie-mesero {
  position: sticky;
  bottom: 0;
  z-index: 2;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.pie-mesero__agregar {
  flex: 1 1 0;
  min-width: 0 !important;
  min-height: 52px !important;
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0;
  color: #fff !important;
}

.pie-mesero__agregar ::v-deep .v-btn__content {
  white-space: normal;
  line-height: 1.15;
  min-width: 0;
}

.v-item--active {
  border: 1px solid rgb(0, 100, 150) !important;
  font-size: 1.2em !important;
  font-weight: bold;
}

.cart-selection-variant-option {
  border: 1px solid #ccc;
  max-width: 25%;
}
</style>
<script>
import CartSectionProductSaleOptions from "./CartSectionProductSaleOptions";
export default {
  name: "CartSectionProductOptions",
  components: { CartSectionProductSaleOptions },
  props: ["itemLine", "currentProduct", "open", "dialog", "priceList", "paraMesero"],
  data: () => ({
    //prices: null
    //isVisible: false
    discountRates: [
      0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
      95, 100,
    ],
    discount: 0,
    quantity: 1,
    options: null,
    optionsItem: {},
    opcionesFaltantes: {},
    intentado: false,
    verNota: false,
    variants: null,
    variantsItem: {},
    variant: null,
    productVariant: null,
    key: 0,
    note: "",
    product: null,
    price: 0,
    currentPriceList: null,
    changePriceListFromForm: false,
    priceIsChange: false,
    cashRegister: null,
    enablePriceChange: false,
  }),
  async mounted() {
    this.clean();
    await this.loadConfig();

    if (this.priceList) {
      this.currentPriceList = {
        id: this.priceList.id,
        name: this.priceList.name,
      };
    }
    if (this.itemLine && this.itemLine.price_list_id) {
      for (const priceList of this.$pos.priceLists) {
        if (this.itemLine.price_list_id == priceList.id) {
          this.currentPriceList = { id: priceList.id, name: priceList.name };
          break;
        }
      }
    }
    if (this.itemLine) {
      if (this.itemLine.percentage_discount) {
        this.discount = this.itemLine.percentage_discount;
      }
      if (this.itemLine.unit_price) {
        this.price = this.itemLine.unit_price;
      }
    } else {
      if (this.product) {
        this.getProductPrice();
      }
    }
    this.setCashRegister();
  },

  computed: {
    esPesado() {
      return !!(this.product && this.product.is_scale);
    },
    unidadDePeso() {
      const u = this.product && this.product.unity;
      return (u && u.name) || 'kg';
    },
    cantidadValida() {
      return Number(this.quantity) > 0;
    },
    enEscritorio() {
      return !!(window.posEscritorio && window.posEscritorio.impresion);
    },
  },
  methods: {
    isOptionDisabled(opt, vr, index) {
      if (index > 0) {
        let prevs = [];
        for (let i = 0; i < index; i++) {
          let prev = this.variants[i];
          if (this.variantsItem[prev.id]) {
            prevs.push(this.variantsItem[prev.id]);
          }
        }

        if (prevs && prevs.length > 0) {
          prevs.push(opt.id);
          let productVariant = this.$db.containsOptions(this.product.id, prevs);
          if (!productVariant) {
            return true;
          }
        }
      }

      return false;
    },
    getProductPrice() {
      if (this.itemLine && !this.changePriceListFromForm) {
        this.price = this.$pos.getSalePrice(
          this.product,
          this.discount,
          this.getPriceListId(),
          this.productVariant?.id
        );
        if (this.discount) {
          return this.$pos.getSalePrice(
            this.product,
            this.discount,
            this.getPriceListId(),
            this.productVariant?.id
          );
        } else {
          return this.price;
        }
      } else {
        this.price = this.$pos.getSalePrice(
          this.product,
          this.discount,
          this.getPriceListId(),
          this.productVariant?.id
        );
        return this.price; //this.$pos.getSalePrice(this.product, this.discount, this.getPriceListId())
      }
    },
    changePriceList() {
      this.changePriceListFromForm = true;
      if (this.currentPriceList) {
        //return this.currentPriceList.id
        this.price = this.$pos.getSalePrice(
          this.product,
          0,
          this.getPriceListId(),
          this.productVariant?.id
        );
      }
    },
    getPriceListId() {
      if (this.currentPriceList) {
        return this.currentPriceList.id;
      }
      return null;
    },
    clean() {
      this.key++;
      this.product = this.currentProduct;
      this.variants = null;
      this.variantsItem = {};
      this.variant = null;
      this.options = null;
      this.opcionesFaltantes = {};
      this.intentado = false;
      this.verNota = false;
      this.optionsItem = {};
      this.note = "";
      this.loadConfig();
      this.priceIsChange = false;
      this.key++;
    },
    /** Productos por peso (is_scale): se venden en kg, con decimales; de a 0.1 con los botones. */
    paso() {
      return this.esPesado ? 0.1 : 1;
    },
    redondear(n) {
      return Math.round(n * 1000) / 1000;
    },
    minus() {
      const q = this.redondear(Number(this.quantity) - this.paso());
      if (q >= (this.esPesado ? 0.001 : 1)) {
        this.quantity = q;
      }
    },
    mas() {
      this.quantity = this.redondear((Number(this.quantity) || 0) + this.paso());
    },
    /** En Colombia el decimal se escribe con coma: se toma como punto. */
    comaPorPunto(e) {
      if (e.key === ',' && this.esPesado && e.target && e.target.setRangeText) {
        e.preventDefault();
        if (String(e.target.value).indexOf('.') === -1) {
          e.target.setRangeText('.', e.target.selectionStart, e.target.selectionEnd, 'end');
          e.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    },
    selectVariant(opt, vr) {
      setTimeout(() => {
        this.checkConstrains();
      }, 200);
    },
    /* selectOption(option, opt){
        this.checkConstrains();
      },*/
    selectedOption(evt) {
      this.$set(this.optionsItem, evt.id, evt.option);
      this.$set(this.opcionesFaltantes, evt.id, "");
    },
    // Los grupos de opciones de venta con mínimo (p. ej. «término de la carne», elige 1) son obligatorios.
    checkOpciones() {
      const faltantes = {};
      for (const opt of this.options || []) {
        const minimo = Number(opt.min_options) || 0;
        if (minimo < 1) continue;
        const elegido = this.optionsItem[opt.id] && this.optionsItem[opt.id].value;
        const cuantas = Array.isArray(elegido) ? elegido.length : elegido ? 1 : 0;
        if (cuantas < minimo) {
          faltantes[opt.id] = minimo === 1 ? "Elige una opción" : `Elige al menos ${minimo} opciones`;
        }
      }
      this.opcionesFaltantes = faltantes;
      return Object.keys(faltantes).length === 0;
    },
    // Lo primero que falta elegir (variante u opción obligatoria), para decírselo al mesero.
    pendiente() {
      const variante = (this.variants || []).find((v) => !this.variantsItem[v.id]);
      if (variante) return variante.name;
      for (const opt of this.options || []) {
        const minimo = Number(opt.min_options) || 0;
        if (minimo < 1) continue;
        const elegido = this.optionsItem[opt.id] && this.optionsItem[opt.id].value;
        const cuantas = Array.isArray(elegido) ? elegido.length : elegido ? 1 : 0;
        if (cuantas < minimo) return opt.name;
      }
      return "";
    },
    textoBoton() {
      const falta = this.pendiente();
      if (falta) return "Elige: " + falta;
      const verbo = this.itemLine ? "Guardar cambios" : "Agregar";
      if (this.enablePriceChange) return verbo;
      return verbo + " · " + this.$filters.currency(this.getProductPrice() * this.quantity);
    },
    irAlPendiente() {
      this.intentado = true;
      this.$nextTick(() => {
        const variante = (this.variants || []).find((v) => !this.variantsItem[v.id]);
        const idOpcion = Object.keys(this.opcionesFaltantes).find((k) => this.opcionesFaltantes[k]);
        const id = variante ? "grupo-v" + variante.id : idOpcion ? "grupo-" + idOpcion : null;
        const el = id && document.getElementById(id);
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    },
    async checkConstrains() {
      if (!(await this.checkVariantes())) return false;
      return this.checkOpciones();
    },
    async checkVariantes() {
      //check variants

      if (this.variants) {
        let allVariants = true;
        for (const v of this.variants) {
          if (!this.variantsItem[v.id]) {
            allVariants = false;
            this.$root.$emit("error", {
              field: v.id,
              message: "Debe seleccionar al menos una opción de: " + v.name,
            });
          } else {
            this.$root.$emit("valid", { field: v.id });
          }
        }
        if (allVariants) {
          let founded = await this.selectedVariant();
          if (!founded) {
            alert("Esta variante no existe");
            this.variantsItem = [];
            allVariants = false;
          } else {
            return true;
          }
        }
        //this.key++;
        return false;
      } else {
        return true;
      }
    },
    async selectedVariant() {
      const options = [];
      for (const i in this.variantsItem) {
        options.push(this.variantsItem[i]);
      }
      console.log(options);
      this.productVariant = this.$db.searchVariant(this.product.id, options);
      if (!this.productVariant) {
        return false;
      }
      return this.productVariant;
    },
    async loadConfig() {
      if (this.itemLine) {
        this.quantity = this.itemLine.quantity;
        this.product = await this.$db.getProduct(this.itemLine.product.id);
        this.note = this.itemLine.note;
      }

      if (this.product.type == "variant") {
        await this.loadVariants();
      }
      if (this.product.sale_options) {
        await this.loadOptions();
      }
    },
    async update() {
      let check = await this.checkConstrains();
      if (!check) {
        this.irAlPendiente();
        return;
      }
      let opts = {
        itemLine: this.itemLine,
        variant: this.productVariant,
        quantity: Number(this.quantity),
        note: this.note,
        options: this.optionsItem,
        discount: this.discount,
        new_price: -1,
        bill_price_list_id: this.currentPriceList.id,
      };
      if (this.priceIsChange) {
        opts.new_price = this.price;
      } else {
        let price = this.$pos.getSalePrice(
          this.product,
          0,
          this.getPriceListId(),
          this.productVariant?.id
        );
        opts.new_price = price;
      }
      this.$emit("selectedOptions", opts);
    },
    getPathProduct(item) {
      if (item) {
        return this.$http.getBaseUrlImagesProducts() + item.image;
      }
      return "@/assets/product-blank.png";
    },
    getProductsByCategory(catId) {
      const prds = this.$db.searchProducts(
        {
          category_id: { $eq: catId },
        },
        30,
        "name"
      );
      return prds;
    },
    async loadOptions() {
      let allOptions = await this.$db.getSaleOptions();
      const optionsProduct = [];
      for (const v of this.product.sale_options) {
        for (const option of allOptions) {
          if (v.id == option.id) {
            optionsProduct.push({
              id: option.id,
              name: option.name,
              option_type: option.option_type,
              apply_price: option.apply_price,
              max_options: option.max_options,
              min_options: option.min_options,
              inv_category_id: option.inv_category_id,
              products: option.products,
              sale_options: option.sale_options,
            });
          }
        }
      }
      this.options = optionsProduct;
      if (this.itemLine && this.itemLine.options) {
        for (const i in this.itemLine.options) {
          this.$set(this.optionsItem, i, this.itemLine.options[i]);
        }
        //currentVariant = await this.$db.adapter.product_variants.findOneById(this.itemLine.product_variant.id);
      }

      this.key++;
    },
    changePrice() {
      this.priceIsChange = true;
    },
    async loadVariants() {
      let allVariants = await this.$db.getVariants();

      const variantsProduct = [];
      this.variantsItem = {}; //variantes seleccionadas
      let currentVariant = null;
      if (
        this.itemLine &&
        this.itemLine.product_variant &&
        this.itemLine.product_variant.id
      ) {
        currentVariant = await this.$db.getProductVariants(
          this.itemLine.product_variant.id
        );
      }
      // se optienen la informacion de las opciones posibles configuradas para el producto de cada variante
      // si itemLine esta seteado se preseleccionan las opciones de variantes correspondientes
      for (const v of this.product.variants.variants) {
        for (const variant of allVariants) {
          if (v.id == variant.id) {
            const options = [];
            for (const opt of this.product.variants["v-" + v.id]) {
              const idx = variant.options.findIndex((o) => o.id == opt.id);
              if (idx >= 0) {
                const option = variant.options[idx];
                option.selected = false;

                if (
                  currentVariant &&
                  currentVariant.inv_variant_option_ids &&
                  currentVariant.inv_variant_option_ids.indexOf(opt.id) >= 0
                ) {
                  option.selected = true;
                  this.variantsItem[v.id] = opt.id;
                }
                options.push(option);
                if (currentVariant && currentVariant.length > 0) {
                  for (const vari of currentVariant) {
                    if (
                      vari &&
                      vari.inv_variant_option_ids &&
                      vari.inv_variant_option_ids.indexOf(opt) >= 0
                    ) {
                      this.variantsItem[v.id] = opt;
                    }
                  }
                }
              }
            }
            variantsProduct.push({
              id: variant.id,
              name: variant.name,
              is_colour: variant.is_colour,
              options: options.sort(function (a, b) {
                return a.name.localeCompare(b.name);
              }),
            });
          }
        }
      }
      this.variants = variantsProduct.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.checkConstrains();
      this.key++;
    },
    async setCashRegister() {
      let installation = this.$store.getters.installation;

      if (installation && !this.cashRegister) {
        this.cashRegister = await this.$db.getCashRegister(
          installation.cash_id
        );
      }

      this.viewPriceChange();
    },
    async viewPriceChange() {
      this.enablePriceChange = false;
      if (this.cashRegister) {
        if (this.cashRegister.config) {
          if (
            this.cashRegister.config.pos_active_price_change &&
            this.itemLine
          ) {
            this.enablePriceChange =
              this.cashRegister.config.pos_active_price_change;
          }
        }
      }
    },
  },
};
</script>